import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { controlVariants } from './controlStyles'

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg'
  leading?: ReactNode
  trailing?: ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, size, leading, trailing, ...props },
  ref,
) {
  const input = (
    <input
      ref={ref}
      className={cn(controlVariants({ size }), leading && 'pl-9', trailing && 'pr-9', className)}
      {...props}
    />
  )
  if (!leading && !trailing) return input
  return (
    <div className="relative">
      {leading ? (
        <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-subtle [&_svg]:size-4">
          {leading}
        </span>
      ) : null}
      {input}
      {trailing ? <span className="absolute inset-y-0 right-2 flex items-center">{trailing}</span> : null}
    </div>
  )
})
